// removed by extract-text-webpack-plugin
module.exports = {"membership-levels":"Options__membership-levels__3CiV9","container":"Options__container__2MTiu","label":"Options__label__1NExR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SuiteKey/Options/Options.scss
// module id = 402
// module chunks = 0